import React, { createContext, useState, useEffect } from 'react';

// Create the language context
export const LanguageContext = createContext();

// Create a provider component
export const LanguageProvider = ({ children }) => {
  // Get the language from localStorage or default to 'en'
  const [language, setLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem('language');
    return savedLanguage || 'en';
  });

  // Update localStorage when language changes
  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
